import Avatar from "./basic-11-avatar.png";
import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import BgOption1 from "./../images/bg-option-1.png";
import BgOption2 from "./../images/bg-option-2.png";
import BgOption3 from "./../images/bg-option-3.png";
import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic11 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #11";
    this.id = "11";
    this.url = "/ai/carousels/basic-11";
    this.description =
      "Create a simple and sleek carousel without the need for your image";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Orlando Diggs",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@ordiggs",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#2A2878",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#ffffff",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Instrument Serif",
          type: "font",
        },
        {
          label: "Secondary Font",
          key: "secondary_font",
          value: "Instrument Sans",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "How to write hooks that don't suck",
            max_words: 8,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Based on tips from 20+ top Linkedin creators:`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "24px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Keep it short",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Your hook should fit on one line and get a point across quickly.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "20px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Tap into emotions",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Make your readers feel something when they read your first line.
            
Emotion-based anecdotes show you understand how they feel.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "20px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Address a problem",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Start with one problem or challenge your reader faces and offer the solution in the body of your post.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "20px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "If you found this useful....",
            max_words: 2,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Repost so others can benefit, too.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Like so I know you enjoyed it.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Comment anything I missed out.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Follow for more!`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getBackgroundColorVariant(common_settings) {
    return this.getBackgroundColor(common_settings) + "20";
  }

  getBackgroundColorVariantSecond(common_settings) {
    return this.getBackgroundColor(common_settings) + "40";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[5]?.value || "Instrument Serif";
  }

  getSecondaryFont(common_settings) {
    return common_settings.elements[6]?.value || "Instrument Sans";
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute inset-x-0 px-[40px] top-[136px] leading-[60px] flex flex-col gap-[16px]">
          <div
            className="text-[60px]"
            style={{
              color: this.getPrimaryColor(commonSettings),
              fontFamily: this.getPrimaryFont(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div className="flex flex-col text-[16px] gap-[6px] leading-[32px]">
            {slide.elements[1]?.value && (
              <div className="flex gap-[8px] items-center">
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.3752 9.04149L15.5 13.1663L11.3752 17.2911L10.1967 16.1126L12.31 13.999L1.33333 13.9997V12.333L12.31 12.3323L10.1967 10.22L11.3752 9.04149ZM4.62479 0.70816L5.8033 1.88668L3.69 3.99899L14.6667 3.99962V5.66629L3.69 5.66566L5.8033 7.77924L4.62479 8.95774L0.5 4.83295L4.62479 0.70816Z"
                    fill={this.getPrimaryColor(commonSettings)}
                  />
                </svg>

                <div
                  style={{
                    color: this.getPrimaryColor(commonSettings),
                  }}
                  className="whitespace-nowrap"
                >
                  {slide.elements[1]?.style ? (
                    <MultilineView
                      element={slide.elements[1]}
                      getPropertyByStyleKey={(styleKey) =>
                        this.getPropertyByStyleKey(styleKey, commonSettings)
                      }
                      getValueByKey={(key) =>
                        this.getValueByKey(key, commonSettings)
                      }
                    />
                  ) : (
                    <TextView text={slide.elements[1]?.value} />
                  )}
                </div>
              </div>
            )}
            {slide.elements[2]?.value && (
              <div className="flex gap-[8px] items-center">
                <svg
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.1665 6.66695H17.5C18.4205 6.66695 19.1667 7.41314 19.1667 8.33359V10.0873C19.1667 10.3049 19.124 10.5205 19.0412 10.7218L16.4625 16.9843C16.334 17.2965 16.0296 17.5003 15.692 17.5003H1.66671C1.20647 17.5003 0.833374 17.1272 0.833374 16.6669V8.33359C0.833374 7.87338 1.20647 7.50029 1.66671 7.50029H4.56824C4.83902 7.50029 5.0929 7.36873 5.24905 7.14752L9.79354 0.709473C9.91229 0.541249 10.1361 0.484992 10.3203 0.577079L11.832 1.33294C12.7084 1.77113 13.161 2.76078 12.9193 3.7103L12.1665 6.66695ZM5.83337 8.82318V15.8336H15.1339L17.5 10.0873V8.33359H12.1665C11.0793 8.33359 10.2832 7.30941 10.5514 6.25577L11.3041 3.29913C11.3525 3.10922 11.262 2.91129 11.0866 2.82365L10.5357 2.54818L6.61067 8.10866C6.40242 8.40368 6.13622 8.64551 5.83337 8.82318ZM4.16671 9.16693H2.50004V15.8336H4.16671V9.16693Z"
                    fill={this.getPrimaryColor(commonSettings)}
                  />
                </svg>

                <div
                  style={{
                    color: this.getPrimaryColor(commonSettings),
                  }}
                  className="whitespace-nowrap"
                >
                  {slide.elements[2]?.style ? (
                    <MultilineView
                      element={slide.elements[2]}
                      getPropertyByStyleKey={(styleKey) =>
                        this.getPropertyByStyleKey(styleKey, commonSettings)
                      }
                      getValueByKey={(key) =>
                        this.getValueByKey(key, commonSettings)
                      }
                    />
                  ) : (
                    <TextView text={slide.elements[2]?.value} />
                  )}
                </div>
              </div>
            )}
            {slide.elements[3]?.value && (
              <div className="flex gap-[8px] items-center">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.07593 16.3535L0.666626 17.3333L1.64647 12.924C1.02116 11.7547 0.666626 10.4187 0.666626 8.99999C0.666626 4.39761 4.39758 0.666656 8.99996 0.666656C13.6023 0.666656 17.3333 4.39761 17.3333 8.99999C17.3333 13.6023 13.6023 17.3333 8.99996 17.3333C7.58121 17.3333 6.24529 16.9788 5.07593 16.3535ZM5.31725 14.5925L5.86186 14.8837C6.81869 15.3954 7.88788 15.6667 8.99996 15.6667C12.6819 15.6667 15.6666 12.6819 15.6666 8.99999C15.6666 5.31809 12.6819 2.33332 8.99996 2.33332C5.31806 2.33332 2.33329 5.31809 2.33329 8.99999C2.33329 10.1121 2.60453 11.1812 3.1162 12.1381L3.40743 12.6827L2.86176 15.1382L5.31725 14.5925Z"
                    fill={this.getPrimaryColor(commonSettings)}
                  />
                </svg>

                <div
                  style={{
                    color: this.getPrimaryColor(commonSettings),
                  }}
                  className="whitespace-nowrap"
                >
                  {slide.elements[3]?.style ? (
                    <MultilineView
                      element={slide.elements[3]}
                      getPropertyByStyleKey={(styleKey) =>
                        this.getPropertyByStyleKey(styleKey, commonSettings)
                      }
                      getValueByKey={(key) =>
                        this.getValueByKey(key, commonSettings)
                      }
                    />
                  ) : (
                    <TextView text={slide.elements[3]?.value} />
                  )}
                </div>
              </div>
            )}
            {slide.elements[4]?.value && (
              <div className="flex gap-[8px] items-center">
                <svg
                  width="17"
                  height="19"
                  viewBox="0 0 17 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.66671 11.8767V13.6178C8.14537 13.4336 7.58446 13.3333 7.00004 13.3333C4.23862 13.3333 2.00004 15.5719 2.00004 18.3333H0.333374C0.333374 14.6514 3.31814 11.6667 7.00004 11.6667C7.57554 11.6667 8.13404 11.7396 8.66671 11.8767ZM7.00004 10.8333C4.23754 10.8333 2.00004 8.59584 2.00004 5.83334C2.00004 3.07084 4.23754 0.833344 7.00004 0.833344C9.76254 0.833344 12 3.07084 12 5.83334C12 8.59584 9.76254 10.8333 7.00004 10.8333ZM7.00004 9.16668C8.84171 9.16668 10.3334 7.67501 10.3334 5.83334C10.3334 3.99168 8.84171 2.50001 7.00004 2.50001C5.15837 2.50001 3.66671 3.99168 3.66671 5.83334C3.66671 7.67501 5.15837 9.16668 7.00004 9.16668ZM12 14.1667V11.6667H13.6667V14.1667H16.1667V15.8333H13.6667V18.3333H12V15.8333H9.50004V14.1667H12Z"
                    fill={this.getPrimaryColor(commonSettings)}
                  />
                </svg>

                <div
                  style={{
                    color: this.getPrimaryColor(commonSettings),
                  }}
                  className="whitespace-nowrap"
                >
                  {slide.elements[4]?.style ? (
                    <MultilineView
                      element={slide.elements[4]}
                      getPropertyByStyleKey={(styleKey) =>
                        this.getPropertyByStyleKey(styleKey, commonSettings)
                      }
                      getValueByKey={(key) =>
                        this.getValueByKey(key, commonSettings)
                      }
                    />
                  ) : (
                    <TextView text={slide.elements[4]?.value} />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute inset-x-0 px-[40px] top-[136px] leading-[60px] flex flex-col gap-[16px]">
          <div
            className="text-[48px]"
            style={{
              color: this.getPrimaryColor(commonSettings),
              fontFamily: this.getPrimaryFont(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div
            className="text-[20px] leading-[32px]"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute inset-x-0 px-[40px] top-[136px] leading-[60px] flex flex-col gap-[16px]">
          <div
            className="text-[60px]"
            style={{
              color: this.getPrimaryColor(commonSettings),
              fontFamily: this.getPrimaryFont(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div
            className="text-[24px] leading-[36px]"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getSecondaryFont(commonSettings),
        }}
      >
        <div className="absolute inset-0">
          <div className="absolute top-[56px] left-[40px] inline-flex h-[40px] items-center gap-3">
            <img
              className="object-cover w-[56px] h-[56px] rounded-full"
              src={
                commonSettings.elements[1].value.image
                  ? commonSettings.elements[1].value.image
                  : LogoPlaceholder
              }
              alt=""
            />
            <div>
              <p
                className="text-[16px] font-semibold whitespace-nowrap"
                style={{ color: this.getPrimaryColor(commonSettings) }}
              >
                {commonSettings.elements[0].value}
              </p>
              <p
                className="text-[14x] font-normal"
                style={{ color: this.getPrimaryColor(commonSettings) }}
              >
                {commonSettings.elements[2].value}
              </p>
            </div>
          </div>
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
            ></div>
          )}
        </div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        <div className="absolute inset-x-0 bottom-0 top-[428px] left-[328px]">
          <div className="flex items-end justify-between gap-6">
            {index !== 0 && index !== carouselLength - 1 && (
              <div
                className="inline-flex items-center justify-center w-[40px] h-[40px] rounded-full relative"
                style={{
                  color: this.getPrimaryColor(commonSettings),
                }}
              >
                <svg
                  width="42"
                  height="43"
                  viewBox="0 0 42 43"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="absolute top-[-1px] left-[-1px]"
                >
                  <path
                    d="M31.2633 2.15638C8.85936 -5.24186 -11.4241 24.7778 10.2616 37.7433C31.5849 50.4937 51.4681 22.7689 34.786 6.91441"
                    stroke={this.getPrimaryColor(commonSettings)}
                    strokeWidth="2"
                    strokeMiterlimit="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p
                  className="text-[24px] italic"
                  style={{
                    fontFamily: this.getPrimaryFont(commonSettings),
                  }}
                >
                  {index + 1}
                </p>
              </div>
            )}
          </div>
        </div>
        {index === 0 && (
          <div className="absolute top-[404px] left-[278px]">
            <svg
              width="90"
              height="64"
              viewBox="0 0 90 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M89.2432 20.9688C77.6962 16.0546 68.0073 8.21843 57.3894 1.71041C57.1239 1.57759 56.8585 1.44477 56.7257 1.44477C56.4601 -0.149026 54.0713 -0.680295 53.6731 1.17914C52.8767 4.76519 52.8767 8.48406 53.6731 12.0701C47.0366 9.41378 39.7368 8.21843 32.7024 6.62463C27.9243 5.56209 23.1463 4.63238 18.5009 3.43703C16.9082 3.03858 15.4483 2.64012 13.8556 2.10886C13.0592 1.84322 11.3338 0.913507 11.3338 1.71041C11.3338 1.71041 11.3338 1.71041 11.2011 1.71041C10.6702 1.04632 9.47567 0.913507 9.21022 1.97604C9.07749 2.37449 9.21022 2.77294 9.47567 3.17139C7.75025 4.89801 6.02484 6.62463 4.69759 8.74969C3.76852 10.2107 2.30855 12.2029 1.91038 14.0624C1.77766 14.1952 1.77766 14.1952 1.77766 14.328C-0.61138 22.9611 0.0522412 33.4536 0.184966 42.3523C0.31769 47.0009 -0.345932 58.8216 5.09577 61.0795C5.75939 61.3451 6.29028 60.8139 6.55573 60.2826C10.9356 62.8061 19.2973 59.7513 23.1463 58.6888C30.3134 56.6963 37.6132 54.3058 44.5149 51.3839C44.5149 53.1105 44.5149 54.9697 44.6476 56.6963C44.7803 58.5558 44.7803 61.2123 46.506 62.4074C45.9751 63.2043 46.7714 64.3997 47.8332 63.8682C61.1054 57.0946 75.7053 50.5867 86.5887 40.2268C87.2523 39.5627 87.1194 38.7658 86.5887 38.2346C87.1194 36.1095 87.5176 33.9844 88.0485 31.9922C88.5794 29.8671 89.5084 27.3436 89.1103 25.0857C89.1103 24.9529 88.9775 24.6873 88.8446 24.5544C89.1103 24.2888 89.3755 24.0232 89.6409 23.7575C90.1723 22.9611 90.1723 21.3673 89.2432 20.9688ZM12.794 5.29646C22.4829 9.67941 49.6914 12.9998 54.2042 13.6639C54.8678 14.4608 56.5932 14.1952 56.4603 12.9998C56.1948 10.2107 56.1948 7.42153 56.4603 4.49956C65.8837 11.0076 75.0419 18.0469 85.5269 22.8283C76.5017 31.5942 67.211 39.2975 57.1239 46.7353C56.9912 46.6025 56.8582 46.4694 56.593 46.4694C56.1948 45.5397 56.4603 43.2818 56.593 42.2193C56.7257 40.6255 57.3894 37.9692 56.3276 36.641C55.7967 36.1099 54.8676 36.1099 54.204 36.641C53.9383 36.9068 53.8058 37.1723 53.6731 37.4381C53.5404 37.4381 53.4076 37.4381 53.4076 37.4381C46.506 39.563 39.6041 41.4224 32.7024 43.0162C26.9953 44.3444 20.6245 45.6725 15.581 48.9929C16.7755 43.0162 14.5192 35.3128 13.7228 29.4689C12.5285 21.2345 11.5995 13.5311 12.794 5.29646ZM84.8635 30.9301C84.3326 33.4536 83.6688 36.1099 83.5363 38.6335C72.6527 47.5322 59.9111 52.9777 48.3641 60.681C48.3641 59.2201 47.5678 57.6263 47.4353 56.1651C47.1696 54.1728 47.0369 52.0477 47.0369 49.9227C47.7007 48.9929 46.7714 47.1335 45.3115 47.532C39.0732 49.657 32.8354 52.1805 26.5973 54.1728C21.6865 55.7666 11.5995 60.0167 6.68867 57.2276C6.42323 57.0948 6.02505 57.0948 5.7596 57.0948C5.09598 55.3682 4.43236 53.7743 4.16691 51.9149C3.23784 47.1337 3.37057 42.0867 3.37057 37.1723C3.37057 30.5314 4.69781 22.8281 3.50329 16.0544C3.63601 16.0544 3.90146 15.9216 4.03419 15.7888C5.62688 14.3278 6.42323 11.9371 7.48502 10.0776C8.14864 8.88229 8.67954 7.68694 9.21044 6.49159C8.01592 12.2027 8.94499 18.5779 9.60861 24.0234C10.1395 28.9376 10.9359 33.8518 11.5995 38.7661C12.1304 42.4851 11.8649 46.3368 12.6613 50.0557C12.794 50.8526 13.5903 51.1182 14.254 50.9854V51.118C14.254 51.2508 14.3867 51.3839 14.5194 51.5165C16.1121 52.1808 17.0412 51.3839 18.5011 50.587C22.6156 48.5945 27.3937 47.5322 31.7736 46.4694C38.808 44.7428 46.6387 43.8133 53.2751 40.7585C53.2751 41.5554 53.1424 42.2193 53.1424 43.0162C53.0097 44.7428 52.7442 47.2663 54.2042 48.5945C54.7349 49.1258 55.5314 49.1258 56.0621 48.8603C56.1948 49.5244 56.8585 50.0557 57.7875 49.7901C68.273 46.071 77.4307 36.3756 85.3942 28.0079C85.1287 28.9378 84.996 30.0004 84.8635 30.9301Z"
                fill={this.getPrimaryColor(commonSettings)}
              />
            </svg>
          </div>
        )}
      </div>
    );
  }
}

export default Basic11;
